module.exports = __webpack_public_path__ + "static/img/point_qd_not.1a7aa044.png";